/* SerranoMarkt | BTS second-box builder flow | QA only */
(() => {
  'use strict';
  const B = window.SerranoBtsSecondBox;
  if (!B || B.builderReady) return;
  B.builderReady = true;

  const resetFlow = (builder) => {
    const flow = builder.__bts2Flow;
    if (!flow) return;
    flow.panel.hidden = true;
    flow.trigger.setAttribute('aria-expanded', 'false');
    flow.shell?.remove();
    flow.shell = null;
    flow.firstSignature = '';
    builder.closest('.dnhb')?.classList.remove('bts2-custom-open');
  };
  const sync = (builder) => {
    const flow = builder.__bts2Flow;
    if (!flow) return;
    const snapshot = B.snapshot(builder);
    const ready = Boolean(snapshot && !builder.pending);
    flow.trigger.disabled = !ready;
    flow.triggerPrice.textContent = ready
      ? `İndirimli 2. kutuda ${B.discountedUnitText(snapshot.price, snapshot.pack)}`
      : 'Önce ilk kutunu tamamla';
    if (flow.firstSignature && flow.firstSignature !== B.signature(builder)) resetFlow(builder);
    const seed = builder.__bts2ExternalSeed;
    flow.grid.classList.toggle('is-seed-mode', Boolean(seed));
    if (seed && snapshot) {
      const label = builder.querySelector('[data-add-label]');
      const priceNode = builder.querySelector('[data-add-cart] strong');
      if (label) label.textContent = 'İKİ KUTUYU BİRLİKTE SEPETE EKLE';
      if (priceNode) priceNode.textContent = `Kampanyalı toplam ${B.formatTry(B.estimatedPairTotal(seed.price, snapshot.price))}`;
    }
  };
  const patchRender = (builder) => {
    if (builder.__bts2RenderPatched || typeof builder.render !== 'function') return;
    builder.__bts2RenderPatched = true;
    const original = builder.render.bind(builder);
    builder.render = function (...args) {
      const result = original(...args);
      queueMicrotask(() => sync(this));
      return result;
    };
  };
  const pairBuilders = async (firstBuilder, secondBuilder, button, errorNode) => {
    const first = B.snapshot(firstBuilder);
    const second = B.snapshot(secondBuilder);
    if (!first || !second) {
      if (errorNode) errorNode.textContent = 'İki kutunun seçimleri tamamlanmadı.';
      return;
    }
    await B.addItems({
      items: [B.builderLine(first, 1), B.builderLine(second, 2)], button, errorNode,
      tracking: { mode: 'custom_second_box', firstPack: first.pack, secondPack: second.pack, estimatedTotal: B.estimatedPairTotal(first.price, second.price) / 100 }
    });
  };
  const createSecond = (builder) => {
    const flow = builder.__bts2Flow;
    const first = B.snapshot(builder);
    if (!flow || !first) return;
    flow.shell?.remove();
    flow.firstSignature = first.signature;
    const shell = document.createElement('section');
    shell.className = 'bts2-second-shell';
    shell.setAttribute('aria-label', 'İkinci kutunu oluştur');
    shell.innerHTML = `<header class="bts2-second-shell__header"><div><span>2. KUTU</span><h3>RENKLERİNİ SEÇ</h3><p>İlk kutun kaydedildi. İkinci kutunun boyutunu, kesimini ve renklerini seç.</p></div><button type="button" class="bts2-second-shell__cancel">İkinci kutudan vazgeç</button></header>`;
    const second = flow.pristine.cloneNode(true);
    const suffix = `bts2-${++B.uid}`;
    second.removeAttribute('data-ready');
    second.removeAttribute('data-serrano-production-fix');
    second.classList.remove('is-mobile-preview-fixed');
    second.dataset.btsSecondBuilder = 'true';
    B.remapIds(second, suffix);
    shell.append(second);
    builder.insertAdjacentElement('afterend', shell);
    flow.shell = shell;
    builder.closest('.dnhb')?.classList.add('bts2-custom-open');
    shell.querySelector('.bts2-second-shell__cancel')?.addEventListener('click', () => resetFlow(builder));
    requestAnimationFrame(() => {
      second.setPack?.(first.pack);
      const addButton = second.querySelector('[data-add-cart]');
      const errorNode = second.querySelector('[data-error]');
      second.addToCart = () => pairBuilders(builder, second, addButton, errorNode);
      const original = second.render?.bind(second);
      if (original) {
        second.render = function (...args) {
          const result = original(...args);
          queueMicrotask(() => {
            const current = B.snapshot(this);
            const label = this.querySelector('[data-add-label]');
            const priceNode = this.querySelector('[data-add-cart] strong');
            if (current && label) label.textContent = 'İKİ KUTUYU BİRLİKTE SEPETE EKLE';
            if (current && priceNode) priceNode.textContent = `Kampanyalı toplam ${B.formatTry(B.estimatedPairTotal(first.price, current.price))}`;
          });
          return result;
        };
        second.render();
      }
      B.scrollTo(shell);
    });
  };
  const samePair = async (builder, button, errorNode) => {
    const first = B.snapshot(builder);
    if (!first) {
      if (errorNode) errorNode.textContent = 'İlk kutu seçimi tamamlanmadı.';
      return;
    }
    await B.addItems({
      items: [B.builderLine(first, 1), B.builderLine(first, 2)], button, errorNode,
      tracking: { mode: 'same_colours', firstPack: first.pack, secondPack: first.pack, estimatedTotal: B.estimatedPairTotal(first.price, first.price) / 100 }
    });
  };

  B.enhanceBuilder = (builder) => {
    if (!builder || builder.dataset.btsSecondBuilder === 'true' || builder.dataset.btsSecondBoxEnhanced === 'true') return;
    const action = builder.querySelector('.dnhb__action');
    const addButton = builder.querySelector('[data-add-cart]');
    if (!action || !addButton) return;
    builder.dataset.btsSecondBoxEnhanced = 'true';
    const pristine = builder.cloneNode(true);
    pristine.removeAttribute('data-ready');
    const grid = document.createElement('div');
    grid.className = 'bts2-action-grid';
    addButton.before(grid);
    grid.append(addButton);
    const trigger = document.createElement('button');
    const panelId = `BtsSecondChoice-${++B.uid}`;
    trigger.type = 'button';
    trigger.className = 'bts2-add-second';
    trigger.disabled = true;
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', panelId);
    trigger.innerHTML = `<span class="bts2-add-second__eyebrow">BACK TO SCHOOL</span><strong class="bts2-add-second__title" data-bts2-title>2. KUTUYU %50 İNDİRİMLE EKLE</strong><small class="bts2-add-second__price" data-bts2-price>Önce ilk kutunu tamamla</small>`;
    grid.append(trigger);
    const panel = document.createElement('div');
    panel.className = 'bts2-choice-panel';
    panel.id = panelId;
    panel.hidden = true;
    panel.innerHTML = `<div class="bts2-choice-panel__header"><div><strong>İKİNCİ KUTUN NASIL OLSUN?</strong><small>Henüz sepete ürün eklenmedi. Seçimini bitirdiğinde iki kutu birlikte eklenecek.</small></div><button type="button" class="bts2-choice-close">Kapat</button></div><div class="bts2-choice-panel__options"><button type="button" class="bts2-choice-option bts2-choice-option--same" data-bts2-same><strong>AYNI RENKLERLE EKLE</strong><span>İlk kutunun aynısından iki kutuyu birlikte sepete ekle.</span></button><button type="button" class="bts2-choice-option" data-bts2-custom><strong>2. KUTUNUN RENKLERİNİ BEN SEÇECEĞİM</strong><span>Aşağıda ikinci bir kutu aç ve seçimlerini ayrı yap.</span></button></div><p class="bts2-ready-status" data-bts2-error role="alert"></p>`;
    grid.after(panel);
    const errorNode = panel.querySelector('[data-bts2-error]');
    builder.__bts2Flow = { grid, trigger, triggerPrice: trigger.querySelector('[data-bts2-price]'), panel, pristine, shell: null, firstSignature: '' };
    trigger.addEventListener('click', () => {
      if (trigger.disabled) return;
      panel.hidden = !panel.hidden;
      trigger.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      if (!panel.hidden) {
        errorNode.textContent = '';
        builder.__bts2Flow.firstSignature = B.signature(builder);
        B.scrollTo(panel);
      }
    });
    panel.querySelector('.bts2-choice-close')?.addEventListener('click', () => resetFlow(builder));
    panel.querySelector('[data-bts2-same]')?.addEventListener('click', (event) => samePair(builder, event.currentTarget, errorNode));
    panel.querySelector('[data-bts2-custom]')?.addEventListener('click', () => createSecond(builder));
    patchRender(builder);
    sync(builder);
  };

  B.clearExternalSeed = (builder) => {
    delete builder.__bts2ExternalSeed;
    delete builder.addToCart;
    builder.querySelector('.bts2-seed-summary')?.remove();
    sync(builder);
    builder.render?.();
  };
  B.activateExternalSeed = (builder, seed) => {
    if (!builder || !seed?.variantId || !seed?.price || !seed?.pack) return;
    B.enhanceBuilder(builder);
    builder.__bts2ExternalSeed = seed;
    builder.querySelector('.bts2-seed-summary')?.remove();
    const summary = document.createElement('div');
    summary.className = 'bts2-seed-summary';
    summary.innerHTML = `<div><span>1. KUTU HAZIR</span><strong>${seed.title}</strong></div><button type="button">Hazır kutuyu kaldır</button>`;
    builder.querySelector('.dnhb__grid')?.before(summary);
    summary.querySelector('button')?.addEventListener('click', () => B.clearExternalSeed(builder));
    const addButton = builder.querySelector('[data-add-cart]');
    const errorNode = builder.querySelector('[data-error]');
    builder.addToCart = async () => {
      const second = B.snapshot(builder);
      if (!second) return;
      await B.addItems({
        items: [B.readyLine(seed, 1), B.builderLine(second, 2)], button: addButton, errorNode,
        tracking: { mode: 'ready_plus_custom', firstPack: seed.pack, secondPack: second.pack, estimatedTotal: B.estimatedPairTotal(seed.price, second.price) / 100 }
      });
    };
    builder.setPack?.(seed.pack);
    builder.render?.();
    B.scrollTo(summary);
  };
})();
